import { Salary } from '../models';

export function formatSalaryNumber(num: number): string {
    if (num < 10000) {
        return num.toString();
    }
    const units = ['k', 'm', 'b'];
    const unitIndex = Math.floor(Math.log10(num) / 3);
    const unit = units[Math.max(0, Math.min(unitIndex - 1, units.length - 1))];
    const formattedNum = num / 10 ** (unitIndex * 3);
    const formattedNumString =
        formattedNum % 1 === 0 || unit === 'k' ? formattedNum.toFixed(0) : formattedNum.toFixed(1);
    return `${formattedNumString}${unit}`;
}

export function formatSalary(salary: Salary | undefined | null, interval?: string): string | undefined {
    if (salary === undefined || salary === null) {
        return undefined;
    }

    const { yearlySalaryFrom, yearlySalaryTo, currency } = salary;
    const from = formatSalaryNumber(yearlySalaryFrom);
    const to = formatSalaryNumber(yearlySalaryTo);

    let result = `${currency} ${from} - ${to}`;

    if (interval) {
        result += ` (${interval})`;
    }

    return result;
}
